// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RuEp6","content":"styles_content__3UIbH"};